module.exports = __webpack_public_path__ + "static/themasterlist-meta-image-01c8540ada83c9348616382fab8aea06.png";